<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div>
              <span class="loading-request" v-show="loading"></span>
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom"
              >
                <h1 class="h2">Bonificações</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                  <div
                    class="btn-group btn-group-sm"
                    role="group"
                    aria-label="Menu das bonificações"
                  >
                    <span
                      class="btn btn-outline-brand"
                      @click="openNewBonusModal('add')"
                      v-b-tooltip.hover
                      title="Nova bonificação"
                    >
                      <i class="fas fa-plus-square"></i>&nbsp; Cadastrar
                    </span>
                  </div>
                </div>
              </div>
              <div class="page-amounts">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ selected: amount === 3 }">
                      <a @click="amount = 3" class="page-link paginate">3</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 10 }">
                      <a @click="amount = 10" class="page-link paginate">10</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 50 }">
                      <a @click="amount = 50" class="page-link paginate">50</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 100 }">
                      <a @click="amount = 100" class="page-link paginate">100</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 150 }">
                      <a @click="amount = 150" class="page-link paginate">150</a>
                    </li>
                  </ul>
                </nav>
              </div>
              <div class="paginator-info-top m-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
            </div>
            <div class="table-responsive">
              <div class="container-table">
                <table class="table table-striped- table-bordered table-hover table-checkable">
                  <thead>
                    <tr>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="60"
                        :class="{ 'table-sorted': sortType === 'customer_id' }"
                        @click="sortCall('customer_id')"
                      >
                        ID Cliente
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType === 'customer_id' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType === 'customer_id' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType !== 'customer_id'"></span>
                      </td>
                      <td nowrap class="text-center align-middle" width="300">Cliente</td>
                      <td nowrap class="text-center align-middle" width="50">Quantidade</td>
                      <td nowrap class="text-center align-middle" width="30">Ações</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @keypress="validateValueNumber"
                          @input="callData"
                          v-model="filters.id"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callData"
                          v-model="filters.name"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @keypress="validateValueNumber"
                          @input="callData"
                          v-model="filters.quantity"
                        />
                      </td>
                      <td></td>
                    </tr>
                    <tr v-for="(bonus, id) in data.data" :key="id">
                      <td class="text-center align-middle">{{ bonus.customer_id }}</td>
                      <td class="text-left align-middle">
                        {{ bonus.customer.customerable.co_name }}
                      </td>
                      <td class="text-center align-middle">{{ bonus.quantity }}</td>
                      <td class="text-center align-middle">
                        <div class="btn-group btn-group-sm btn-collapse-bonus" role="group">
                          <span
                            class="btn btn-outline-brand btn-collapse"
                            @click="
                              openCustomerBonuses(
                                bonus.customer_id,
                                bonus.customer.customerable.co_name
                              )
                            "
                            v-b-tooltip.hover
                            :title="`Bônus de ${bonus.customer.customerable.co_name}`"
                          >
                            <i class="fas fa-plus-square"></i>&nbsp;
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ disabled: data.current_page === 1 }">
                      <a class="page-link paginate" @click="page = 1"
                        ><i class="fal fa-angle-double-left"></i
                      ></a>
                    </li>
                    <li class="page-item" :class="{ disabled: data.current_page === 1 }">
                      <a class="page-link paginate" @click="page = data.current_page - 1"
                        ><i class="fal fa-angle-left"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === 1 }"
                      v-if="data.current_page > 2"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 2">
                        {{ data.current_page - 2 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === 1 }"
                      v-if="data.current_page > 1"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 1">
                        {{ data.current_page - 1 }}</a
                      >
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate"> {{ data.current_page }} </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === data.last_page }"
                      v-if="data.current_page < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1">
                        {{ data.current_page + 1 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page + 1 === data.last_page }"
                      v-if="data.current_page + 1 < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 2">
                        {{ data.current_page + 2 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1"
                        ><i class="fal fa-angle-right"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.last_page"
                        ><i class="fal fa-angle-double-right"></i
                      ></a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
      <transition name="slideleft" mode="out-in">
        <CreateBonusModal v-if="showCreateBonus" @updateList="callData" />
      </transition>
      <transition name="fade" mode="out-in">
        <div
          class="m-quick-sidebar-overlay"
          v-if="showCreateBonus"
          @click="closeNewDiscount()"
        ></div>
      </transition>

      <transition name="slideleft" mode="out-in">
        <CustomerBonusesModal
          v-if="showCustomerBonuses"
          @updateList="callData"
          :bonusName="currentCustomerName"
        />
      </transition>
      <transition name="fade" mode="out-in">
        <div
          class="m-quick-sidebar-overlay"
          v-if="showCustomerBonuses"
          @click="closeCompanyDiscount()"
        ></div>
      </transition>
    </div>
  </div>
</template>

<script>
import CreateBonusModal from '@/components/customer-bonus/CreateBonusModal';
import CustomerBonusesModal from '@/components/customer-bonus/CustomerBonusesModal';
import { validationFilterValueMixin } from '@/mixins/validationFilterValueMixin';
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageFormMixin, validationFilterValueMixin],
  name: 'Discount',
  components: { CreateBonusModal, CustomerBonusesModal },
  data() {
    return {
      currentCustomerName: '',
      data: {},
      sortType: localStorage.customerBonusSortType ? localStorage.customerBonusSortType : 'id',
      sortReverse: localStorage.customerBonusSortReverse
        ? localStorage.customerBonusSortReverse
        : false,
      amount: localStorage.customerBonusDataAmount ? localStorage.customerBonusDataAmount : 100,
      page: localStorage.customerBonusDataPage ? localStorage.customerBonusDataPage : 1,
      filters: {
        id: localStorage.customerBonusFilterId ? localStorage.customerBonusFilterId : '',
        name: localStorage.customerBonusFilterName ? localStorage.customerBonusFilterName : '',
        quantity: localStorage.customerBonusFilterQuantity
          ? localStorage.customerBonusFilterQuantity
          : '',
      },
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
    showCreateBonus() {
      return this.$store.state.showCreateBonus;
    },
    showCustomerBonuses() {
      return this.$store.state.showCustomerBonuses;
    },
  },
  methods: {
    changeStatus(customerId) {
      const url = `${baseApiUrl}/v1/customer/status/${customerId}`;
      axios(url)
        .then((res) => {
          this.logMessage(res);
          this.getDatas();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
      this.callData();
    },
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
      this.callData();
    },
    clearFilters() {
      this.filters.id = '';
      this.filters.name = '';
      this.filters.quantity = '';
      this.filters.sortType = 'name';
      this.filters.sortReverse = false;
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('customerBonusFilterId', this.filters.id);
      localStorage.setItem('customerBonusFilterName', this.filters.name);
      localStorage.setItem('customerBonusFilterQuantity', this.filters.quantity);
      localStorage.setItem('customerBonusDataAmount', this.amount);
      localStorage.setItem('customerBonusDataPage', this.page);
      localStorage.setItem('customerBonusSortType', this.sortType);
      localStorage.setItem('customerBonusSortReverse', this.sortReverse);
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }&name=${this.filters.name ? this.filters.name : ''}&quantity=${
        this.filters.quantity ? this.filters.quantity : ''
      }&sortType=${this.sortType}&sortOrder=${this.sortReverse ? 'DESC' : 'ASC'}`;
      return filters;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType === sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      const timeWindow = 700;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.data.current_page = null;
        this.setStorageFilters();
        this.getDatas();
      }, timeWindow);
    },
    getDatas() {
      this.getCustomersWithDiscounts();
    },
    openNewBonusModal() {
      this.$store.state.showCreateBonus = true;
    },
    closeNewDiscount() {
      this.$store.state.showCreateBonus = null;
      this.callData();
    },
    openCustomerBonuses(id, customerName) {
      this.$store.state.showCustomerBonuses = id;
      this.currentCustomerName = customerName;
    },
    closeCompanyDiscount() {
      this.$store.state.showCustomerBonuses = null;
      this.callData();
    },
    getCustomersWithDiscounts() {
      const url = `${baseApiUrl}/v1/customer/bonus/list${this.convertFilters()}`;

      axios
        .get(url)
        .then((res) => {
          this.data = res.data;
        })
        .catch((error) => {
          this.logMessageFormFailed(error.response);
        });
    },
  },
  watch: {
    amount() {
      if (this.page === 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    this.getDatas();
    window.scroll(0, 0);
  },
};
</script>
